import {
  boolean,
  enum_,
  integer,
  literal,
  nullable,
  number,
  object,
  optional,
  pipe,
  string,
  type InferOutput
} from 'valibot'
import { OptionalNullableProfileIDSchema, ProfileIdSchema } from './lib/core/ProfileId.type'
import { StateSchema } from './lib/core/state/State.type'
import { StateOnlineIdSchema } from './lib/core/state/StateOnlineId.type'
import { ActionUnionSchema } from './lib/core/state/flux/ActionUnion.type'
import { ClientRefIDSchema } from './lib/core/state/flux/nextClientReferenceId'
import { BioSchema } from './lib/valibot/schema/Bio.type'
import { EmailSchema } from './lib/valibot/schema/Email.type'
import { HandleSchema } from './lib/valibot/schema/Handle.type'
import { OptionalDisplayNameSchema } from './lib/valibot/schema/DisplayName.type'
import { StringOrIntegerAsIntegerSchema } from './lib/valibot/schema/StringOrIntegerAsInteger'

// ============ Auth Schemas ============

export enum JwtTokenType {
  ACCESS = 2,
  REFRESH = 3,
}

export const JwtTokenTypeSchema = enum_(JwtTokenType, 'Invalid JWT Token Type')

const JwtTokenExpireSchema = number()
const GuestSchema = optional(literal(1))

export const BackendAccessTokenPayloadSchema = object({
  t: literal(JwtTokenType.ACCESS),
  exp: JwtTokenExpireSchema,
  sub: OptionalNullableProfileIDSchema,
  guest: GuestSchema,
})

export const BackendRefreshTokenPayloadSchema = object({
  t: literal(JwtTokenType.REFRESH),
  exp: JwtTokenExpireSchema,
  sub: OptionalNullableProfileIDSchema,
  guest: GuestSchema,
})

export const BackendSessionPayloadSchema = object({
  exp: JwtTokenExpireSchema,
  sub: OptionalNullableProfileIDSchema,
  guest: GuestSchema,
  at: string(),
  rt: string(),
})

export type BackendSessionPayload = InferOutput<typeof BackendSessionPayloadSchema>

export const SignInWithOtpRequestSchema = object({
  token: string(),
  otp: string(),
})

export const OtpRequestTokenSchema = object({
  token: string(),
})

// ============ Query Schemas ============

export const IndexGameQuerySchema = object({
  owner_profile_id: optional(nullable(pipe(StringOrIntegerAsIntegerSchema, ProfileIdSchema))),
  player_profile_id: optional(nullable(pipe(StringOrIntegerAsIntegerSchema, ProfileIdSchema))),
})

export const IndexMapQuerySchema = object({
  owner_profile_id: optional(nullable(pipe(StringOrIntegerAsIntegerSchema, ProfileIdSchema))),
})

export const IndexLobbyQuerySchema = object({
  owner_profile_id: optional(nullable(pipe(StringOrIntegerAsIntegerSchema, ProfileIdSchema))),
})

export const IndexReplayQuerySchema = object({
  owner_profile_id: optional(nullable(pipe(StringOrIntegerAsIntegerSchema, ProfileIdSchema))),
})

// ============ Body Schemas ============

export const StoreLobbyBodySchema = object({
  dname: string(),
  bio: nullable(string()),
  passphrase: nullable(string()),
  map_id: StateOnlineIdSchema,
})

export const UpdateLobbyBodySchema = object({
  dname: optional(string()),
  bio: optional(nullable(string())),
  passphrase: optional(nullable(string())),
  public: optional(boolean()),
})

export const StoreMapBodySchema = object({
  state: StateSchema,
})

export const UpdateMapBodySchema = object({
  state: StateSchema,
})

export const UpdateGameBodySchema = object({
  cref: ClientRefIDSchema,
  action: ActionUnionSchema,
})

export const PatchMyProfileBodySchema = object({
  avatar_id: optional(nullable(pipe(number(), integer()))),
  handle: optional(nullable(HandleSchema)),
  dname: OptionalDisplayNameSchema,
  email: optional(EmailSchema),
  bio: optional(BioSchema),
})

export { OtpRequestSchema } from './lib/valibot/schema/OtpRequest.type'
